import { IAgentCard, EAgentCardAccountType } from '../../types/agentCard';

export function isAgency({ accountType }: IAgentCard) {
  return accountType === EAgentCardAccountType.Agency;
}
